// extracted by mini-css-extract-plugin
export default {"divider":"classes_divider__T6IGw"};